
import { Component } from 'vue-property-decorator'
import { ProductApiModel } from '@/interfaces/ProductApiModel'
import { namespace } from 'vuex-class'
import { mixins } from 'vue-class-component'
import lodash from 'lodash'
import ProductRenderer from '../product/ProductRenderer.vue'
import { SummarySection } from '@/interfaces/SummarySection'
import { ModifiedModels } from '@/mixins/ModifiedModels'

const currentModel = namespace('currentModel')
const allModels = namespace('allModels')
const globalValues = namespace('globalValues')
const modelIdeas = namespace('modelIdeas')

@Component({
  components: {
    ProductRenderer
  }
})
export default class Inspiration extends mixins(ModifiedModels) {
  async mounted() {
    await this.loadModelIdeas(this.model.code)
    await this.loadModifiedModels()
    this.loaded = true
  }

  public loaded = false;

  public modifiedModels: Array<{ model: ProductApiModel; price: number | undefined; summarySections: Array<SummarySection> }> = []

  private inspirationProps = [
    'panelFinish', 'metalFinish', 'countertopCategory', 'countertop',
    'sink', 'hardware', 'hardwareFrames', 'edgeProfile', 'accent',
    'accentFrames', 'base', 'baseCategory', 'panelFinishCategory', 'metalFinishCategory', 'upgrade', 'drawerUpgrade'
  ]

  public async loadModifiedModels() {
    for (const inspirationIdea of this.inspirationIdeas) {
      const newModel = lodash.cloneDeep(this.model)

      newModel.configurator.base = 'NONE'
      newModel.configurator.baseCategory = 'NONE'
      newModel.configurator.upgrade = []
      newModel.configurator.drawerUpgrade = null

      newModel.configurator = lodash.mergeWith(newModel.configurator, inspirationIdea, (targetVal, srcVal, key) => {
        if (!this.inspirationProps.some(p => p === key)) {
          return targetVal
        }
      })

      await this.addModifiedModel(newModel, true)
    }
  }

  public selectModel(data: ProductApiModel): void {
    this.hidePopover()
    this.setModel(data)
  }

  @modelIdeas.State
  public inspirationIdeas!: Array<any>

  @modelIdeas.Action
  public loadModelIdeas!: (productCode: string) => Promise<boolean>

  @globalValues.Action
  public hidePopover!: () => Promise<boolean>

  @currentModel.Action
  public setModel!: (data: ProductApiModel) => void

  @allModels.State
  public models!: Array<ProductApiModel>
}
